import { Step, StepLabel, Stepper } from '@mui/material';
import { useEffect, useState, useRef } from 'react';
import { useTranslation } from "react-i18next";
import './therapistClientOnboarding.scss';
import Button from '../../../../components/base/Button/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faShare,
  faPlayCircle,
  faCheckCircle,
  faPaperPlane,
} from '@fortawesome/free-solid-svg-icons';
import { faCirclePause } from '@fortawesome/free-regular-svg-icons';
import Avatar from '../../../../components/base/Avatar/Avatar';
import { useDispatch } from 'react-redux';
import {
  clearModalContent,
  setModalContent,
} from '../../../../redux/modules/modalEvent';
import pencil from '../../../../assets/icons/icon-pencil.svg';
import {
  changeOnboardingStatus,
  getOnBoardingAuditLogs,
} from '../../../../redux/services/loggingServices';
import { getIconNewUser, getVisibleDate, getSvgIcon } from './onboarding.utils';
import { Spinner } from 'react-bootstrap';
import {
  cancelOnboarding,
  fetchUserInformationByIdV1,
  getUserAssignedScheduler,
  getUserSpecificToDosV1,
  invite,
  sendWelcomeEmail,
} from '../../../../api/user';
import { getRelativeTime } from '../../../../latest/src/utils/RelativeTime';
import {
  getToDoButtonLabelForReminderCard,
  getToDoButtonVariant,
} from '../../../../legacy/utils/helpers';
import { fetchTherapistClientMetaData } from '../../../../redux/actions/questionnaireActions';
import {
  AddNoteModal,
  ContactPreferencesModal,
  MatchRequestedModal,
  PauseOnboardingModal,
  ReassignModal,
} from './modals';
import VerifyToDo from 'src/latest/src/components/Todo/VerifyToDo/VerifyToDo';
import VerifyInsuranceToDo from 'src/latest/src/components/Todo/VerifyInsuaranceToDo/VerifyInsuranceToDo';
import { UserServiceSection } from '../../../../latest/src/constants/AppServerConfig';
import ConfirmationModalContainer from '../../../ConfirmationModal/ConfirmationModalContainer';
import { setFlashNotification } from '../../../../redux/modules/flashNotification';
import ConfirmAppointmentTodo from 'src/latest/src/components/Todo/ConfirmAppointmentTodo/ConfirmAppointmentTodo';
import MarkAsCollectedTodo from 'src/latest/src/components/Todo/MarkAsCollectedTodo/MarkAsCollectedTodo';
import { TodoTypeEnums } from 'src/latest/src/constants/TodoType';
import FollowUpTodoModal from 'src/latest/src/components/Todo/FollowUpTodo/FollowUpTodoModal';
import { Typography } from 'src/latest/src/components';
import {
  TherapistClientUpdatedstatus,
  TherapistClientUserStatus,
} from './TherapistClientOnboardingContant';
import {
  OnboardingActionStatus,
  PauseOnboardingModalButtonLabels,
} from './modals/PausedOnboardingModalConstant';
import { UserTypes } from 'src/latest/src';
import PaymentIssueDetectionTodo from 'src/latest/src/components/Todo/PaymentIssueDetection/PaymentIssueDetectionTodo';
import ReviewPatientTodo from 'src/latest/src/components/Todo/ReviewPatientTodo/ReviewPatientTodo';
import TrackVerficationStatusTodo from 'src/latest/src/components/Todo/TrackVerficationStatusTodo/TrackVerficationStatusTodo';
import DisputeTodo from 'src/latest/src/components/Todo/DisputeTodo/DisputeTodo';
import { FollowUpTodo } from 'src/latest/src/constants/FollowUpTodo';
import InsuranceManagementTodo from 'src/latest/src/components/Todo/InsuranceManagement/InsuranceManagementTodo/InsuranceManagementTodo';
import EhrConnectionIssueTodo from 'src/latest/src/components/Todo/EhrConnectionIssue/EhrConnectionIssueTodo';
import ProviderJoinRequestTodo from 'src/latest/src/components/Todo/ProviderJoinRequestTodo/ProviderJoinRequestTodo';

const Pencil = ({ onClick }) => (
  <span className="edit-icon me-4 cursor-pointer btm-8" onClick={onClick}>
    <img src={pencil} alt="pencil" />
  </span>
);

const ReminderCard = ({ onClick, activeTodo }) => {
  let content = activeTodo?.content?.replace('{fullname}', '');

  if (activeTodo?.type === TodoTypeEnums?.ADDITIONAL_CONSENT_REQUIRED_TODO) {
    content = content?.replace('{participantname}', '');
  } else if (activeTodo?.type === TodoTypeEnums?.INSURANCE_REQUEST_TODO) {
    content = content?.replace(
      '{insuranceTitle}',
      activeTodo?.metadata?.insurance_title || '',
    );
  } else {
    content = content?.replace('{providername}', '');
  }

  return (
    <>
      <div className="reminder-card">
        <div className="reminder-card__desc">
          <div className="agoTime mb-1">
            {getRelativeTime(activeTodo?.created_at)}
          </div>
          <div
            className="title"
            title={
              activeTodo?.type ===
              TodoTypeEnums?.PROVIDER_APPOINTMENT_CONFIRMATION_TODO
                ? activeTodo?.metadata?.client_name
                : activeTodo?.user_full_name
            }
          >
            <span className="userName">
              {activeTodo?.type ===
              TodoTypeEnums?.PROVIDER_APPOINTMENT_CONFIRMATION_TODO
                ? activeTodo?.metadata?.client_name
                : activeTodo?.user_full_name}
            </span>
            {content}
            <b>
              {activeTodo?.type ===
              TodoTypeEnums?.PROVIDER_APPOINTMENT_CONFIRMATION_TODO
                ? ''
                : activeTodo?.type ===
                  TodoTypeEnums?.ADDITIONAL_CONSENT_REQUIRED_TODO
                ? activeTodo?.participant_name
                : activeTodo?.provider_full_name}
            </b>
          </div>
          <div className="subTitle">{activeTodo?.sub_content}</div>
        </div>
        <div className="reminder-card__btn">
          <Button
            onClick={onClick}
            className={
              activeTodo.type ===
              TodoTypeEnums?.ADDITIONAL_CONSENT_REQUIRED_TODO
                ? 'additional-consent-req-btn'
                : activeTodo.type === TodoTypeEnums?.DISPUTE_PAYMENT_TODO ||
                  activeTodo.type ===
                    TodoTypeEnums?.EHR_USER_CREATION_FAILED_TODO ||
                  activeTodo.type ===
                    TodoTypeEnums?.PRACTICE_OWNER_JOIN_REQUEST_TODO ||
                  activeTodo.type === TodoTypeEnums?.PROVIDER_JOIN_REQUEST_TODO
                ? 'btn-danger'
                : 'card_btn followed-up-btn'
            }
            buttonName={
              activeTodo?.type ===
              TodoTypeEnums?.ADDITIONAL_CONSENT_REQUIRED_TODO
                ? 'collect'
                : 'follow-up'
            }
            variant={getToDoButtonVariant(activeTodo.type)}
          >
            {getToDoButtonLabelForReminderCard(activeTodo)}
          </Button>
        </div>
      </div>
    </>
  );
};

const ContactCard = ({ onClick, selectedUserInfo }) => {
  return (
    <div className="reminder-card">
      <div className="reminder-card__desc">
        <div className="info-group">
          <div className="info-title">TELEPHONE</div>
          <div className="info-description">
            {selectedUserInfo?.telephone_number}
          </div>
        </div>
        <div className="info-group">
          <div className="info-title">EMAIL</div>
          <div className="info-description">{selectedUserInfo?.email}</div>
        </div>
        <div className="info-group">
          <div className="info-title d-flex">
            CONTACT PREFERENCES
            <Pencil
              onClick={() => {
                onClick('contact-info');
              }}
            />
          </div>
          <div className="info-description">
            {selectedUserInfo?.contact_preference}
          </div>
        </div>
      </div>
    </div>
  );
};

const PorfileCard = ({ onClick, assignedTo }) => {
  const image = assignedTo?.profile_pic || '';

  return (
    <div className="profile-card">
      <div className="contents">
        <div className="avatar-container">
          <Avatar
            userId="1234"
            photoUrl={image}
            fullName={assignedTo?.full_name}
            size={'50px'}
            imageSize="M"
          />
        </div>
        <div className="message">
          <span className="text">ASSIGNED TO</span>
          <div className="username">{assignedTo?.full_name}</div>
        </div>
        <Button
          onClick={() => onClick('reassign')}
          className="button reassign-button bg-white "
          variant={'light'}
        >
          <FontAwesomeIcon icon={faShare} />
          Reassign
        </Button>
      </div>
    </div>
  );
};

const ActivityBoardRow = ({ row }) => {
  return (
    <StepLabel
      icon={
        row?.metadata?.uiDisplayIcon === 'faPhoneSlash' ||
        row?.metadata?.uiDisplayIcon === 'fabellCheck' ? (
          getSvgIcon(row)
        ) : (
          <FontAwesomeIcon
            icon={getIconNewUser(row)}
            style={{
              color: row?.metadata?.uiDisplayIconColor || '2AC9CF',
            }}
            className="row-icon"
            flip={
              row?.metadata?.uiDisplayIcon === 'faStickyNote' && 'horizontal'
            }
          />
        )
      }
    >
      <div className="activity-board-row">
        <div className="title-container">
          {row.action_details && (
            <div className="title">{row.action_details}</div>
          )}
          {row.activity && (
            <div className="description">
              {' '}
              —{' '}
              <div
                className="userDetailsContainer"
                dangerouslySetInnerHTML={{
                  __html: row.activity,
                }}
              />
            </div>
          )}
        </div>
        {row.created_at && (
          <div className="datetime">
            {getVisibleDate(row.created_at)}
            {/* <div>— User did not advance to the next onboarding status within 60 days</div> */}
          </div>
        )}
        {row.comments && (
          <div className="message">
            <q>{row.comments}</q>
          </div>
        )}
      </div>
    </StepLabel>
  );
};

function ThearpistClientOnboarding({ selectedUserId, selectedUserContext }) {
  const { t } = useTranslation('therapistClientProfileModals');
  const dispatch = useDispatch();
  const [auditLogs, setAuditLogs] = useState([]);
  const [isActivityLoading, setIsActivityLoading] = useState(true);
  const [selectedUserInfo, setselectedUserInfo] = useState(selectedUserContext);
  const [onboardingActionStatus, setOnboardingActionStatus] = useState(
    OnboardingActionStatus?.PAUSE_ONBOARDING,
  );
  const [inviteLabel, setInviteLabel] = useState('');
  const [inviteClientLabel, setClientInviteLabel] = useState('');
  const [isStatusUpdating, setIsStatusUpdating] = useState(false);
  const [buttonIcon, setbuttonIcon] = useState();
  const [activeTodo, setActiveTodo] = useState([]);
  const [assignedTo, setassignedTo] = useState({});
  // const [isActiveTodo,setIsActiveTodo] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [hasMore, setHasMore] = useState(false);
  const perPage = 20;
  const loadMoreAuditLogTrigger = useRef();
  const [isMoreActivityLoading, setIsMoreActivityLoading] = useState(false);
  const [isSendingEmail, setIsSendingEmail] = useState(false);
  // const [onboardingStatusNote,setonboardingStatusNote]= useState('');

  useEffect(() => {
    init();
  }, []);

  const onIntersect = async entries => {
    const firstElement = entries[0];

    if (firstElement.isIntersecting) {
      if (currentPage < totalPages && hasMore) {
        setCurrentPage(currentPage + 1);

        setIsActivityLoading(false);
      } else {
        setIsMoreActivityLoading(false);
        // setHasMore(false);
      }
    }
  };

  useEffect(() => {
    const option = {
      root: null,
      rootMargin: '10px',
      threshold: [1.0],
      delay: 2000,
    };
    const observer = new IntersectionObserver(onIntersect, option);

    if (observer && loadMoreAuditLogTrigger.current) {
      observer.observe(loadMoreAuditLogTrigger.current);
    }

    return () => {
      if (observer) {
        observer.disconnect();
      }
    };
  }, [auditLogs]);

  useEffect(async () => {
    if (currentPage > 0 && hasMore && currentPage < totalPages) {
      setIsMoreActivityLoading(true);
      const auditLogResp = await getOnBoardingAuditLogs(
        selectedUserId,
        currentPage,
      );

      if (auditLogResp.user_audit_logs !== []) {
        setAuditLogs(prevauditLogs => [
          ...prevauditLogs,
          ...auditLogResp.user_audit_logs,
        ]);
      }

      setIsMoreActivityLoading(false);
    }
  }, [currentPage]);

  useEffect(() => {
    setHasMore(true);
  }, [totalPages]);

  const init = async () => {
    getUpdatedAuditLogs();
    updateContactPref(true);
    getActiveTodoForSelectedUser();
    getusersAssignedScheduler();
  };

  const getUpdatedAuditLogs = currentPageOffset => {
    if (selectedUserId) {
      (async () => {
        setIsActivityLoading(true);
        const resp = await getOnBoardingAuditLogs(
          selectedUserId,
          currentPageOffset || 0,
        );

        setAuditLogs(resp.user_audit_logs);
        setIsActivityLoading(false);
        totalPages > 0 &&
          setTotalPages(() => Math.ceil(resp.pagination.total / perPage));
        // setCurrentPage(resp.pagination.page +1);
        // setHasMore(Math.ceil(resp.pagination.total/perPage) > 1);
      })();
    }
  };

  const updateContactPref = async isFromInit => {
    const selectedUserContext = await fetchUserInformationByIdV1(
      selectedUserId,
      UserServiceSection.profile_display,
      'medium'
    );

    setCurrentPage(0);
    setselectedUserInfo(selectedUserContext);

    !isFromInit && getUpdatedAuditLogs();
    await dispatch(fetchTherapistClientMetaData(selectedUserId));
  };

  const getActiveTodoForSelectedUser = async () => {
    // setIsActiveTodo(false);
    const userActiveTodos = await getUserSpecificToDosV1({
      client_user_id: selectedUserId,
      isCompleted: false,
    });

    setCurrentPage(0);
    setActiveTodo(userActiveTodos.todos || []);
    // userActiveTodos.todos && setIsActiveTodo(true);

    // Fetch latest user info to update status
    const updatedUserInfo = await fetchUserInformationByIdV1(
      selectedUserId,
      UserServiceSection.profile_display,
      'medium'
    );

    setselectedUserInfo(updatedUserInfo);
  };

  const getusersAssignedScheduler = async () => {
    const assinedScheduler = await getUserAssignedScheduler(selectedUserId);

    setassignedTo(assinedScheduler);
  };

  useEffect(() => {
    // set the button label

    if (
      selectedUserInfo?.status?.toLowerCase() ===
        TherapistClientUserStatus?.ONBOARDING_FAILED?.toLowerCase() ||
      selectedUserInfo?.status?.toLowerCase() ===
        TherapistClientUserStatus?.ONBOARDING_PAUSED?.toLowerCase()
    ) {
      setOnboardingActionStatus(OnboardingActionStatus?.RESUME_ONBOARDING);
      setbuttonIcon(faPlayCircle);
    } else if (
      selectedUserInfo?.status?.toLowerCase() ===
        TherapistClientUserStatus?.FIRST_SESSION_COMPLETE?.toLowerCase() ||
      selectedUserInfo?.status?.toLowerCase() ===
        TherapistClientUserStatus?.FIRST_SESSION_SCHEDULED?.toLowerCase() ||
      selectedUserInfo?.status?.toLowerCase() ===
        TherapistClientUserStatus?.PROFILE_COMPLETE?.toLowerCase() ||
      selectedUserInfo?.status?.toLowerCase() ===
        TherapistClientUserStatus?.ONBOARDED_MANUALLY?.toLowerCase() ||
      selectedUserInfo?.status?.toLowerCase() ===
        TherapistClientUserStatus?.PRE_ONBOARD_COMPLETE?.toLowerCase() ||
      selectedUserInfo?.status?.toLowerCase() ===
        TherapistClientUserStatus?.PAPER_WORK_COMPLETE?.toLowerCase() ||
      selectedUserInfo?.status?.toLowerCase() ===
        TherapistClientUserStatus?.SESSION_SCHEDULED?.toLowerCase() ||
      selectedUserInfo?.status?.toLowerCase() ===
        TherapistClientUserStatus?.MIGRATED_FROM_EHR?.toLowerCase()
    ) {
      setOnboardingActionStatus(OnboardingActionStatus?.ONBOARDING_COMPLETE);
      setbuttonIcon(faCheckCircle);
    } else if (
      selectedUserInfo?.status?.toLowerCase() ===
        TherapistClientUserStatus?.PRE_ONBOARD_STARTED?.toLowerCase() ||
      selectedUserInfo?.status?.toLowerCase() ===
        TherapistClientUserStatus?.VERIFIED?.toLowerCase() ||
      selectedUserInfo?.status?.toLowerCase() ===
        TherapistClientUserStatus?.INTAKE_COMPLETE?.toLowerCase() ||
      selectedUserInfo?.status?.toLowerCase() ===
        TherapistClientUserStatus?.MATCHED?.toLowerCase() ||
      selectedUserInfo?.status?.toLowerCase() ===
        TherapistClientUserStatus?.REMATCH_REQUESTED?.toLowerCase() ||
      selectedUserInfo?.status?.toLowerCase() ===
        TherapistClientUserStatus?.ACCOUNT_CREATED?.toLowerCase() ||
      selectedUserInfo?.status?.toLowerCase() ===
        TherapistClientUserStatus?.INVITED?.toLowerCase()
    ) {
      setOnboardingActionStatus(OnboardingActionStatus?.PAUSE_ONBOARDING);
      setbuttonIcon(faCirclePause);
    }
  }, [selectedUserInfo]);

  useEffect(() => {
    if (selectedUserInfo?.status === TherapistClientUserStatus?.INVITED) {
      setInviteLabel('Re Invite');
    } else if (selectedUserInfo?.status === 'Pre-onboard Complete') {
      setInviteLabel('Invite');
    } else {
      setInviteLabel('Send Welcome Email');
    }
  }, [selectedUserInfo]);

  useEffect(() => {
    if (selectedUserInfo?.pre_onboarded_by_scheduler === true) {
      setClientInviteLabel('Invite');
    } else {
      setClientInviteLabel('Send Welcome Email');
    }
  }, [selectedUserInfo]);

  const handleOnboardingStatus = async (
    note: string,
    pausedReason: string | null,
  ) => {
    let updateState = '';

    if (
      selectedUserInfo.status === TherapistClientUserStatus?.INVITED ||
      selectedUserInfo.status === TherapistClientUserStatus?.ACCOUNT_CREATED ||
      selectedUserInfo.status === TherapistClientUserStatus?.INTAKE_COMPLETE ||
      selectedUserInfo.status === TherapistClientUserStatus?.MATCHED ||
      selectedUserInfo.status ===
        TherapistClientUserStatus?.REMATCH_REQUESTED ||
      selectedUserInfo.status ===
        TherapistClientUserStatus?.PRE_ONBOARD_STARTED ||
      selectedUserInfo.status === TherapistClientUserStatus?.VERIFIED
    ) {
      updateState = TherapistClientUpdatedstatus?.PAUSED_ONBOARDING;
    } else if (
      selectedUserInfo.status ===
        TherapistClientUserStatus?.ONBOARDING_PAUSED ||
      selectedUserInfo.status === TherapistClientUserStatus?.ONBOARDING_FAILED
    ) {
      updateState = TherapistClientUpdatedstatus?.RESUME_ONBOARDING;
    }

    setIsStatusUpdating(true);

    if (updateState === TherapistClientUpdatedstatus?.PAUSED_ONBOARDING) {
      await cancelOnboarding(selectedUserId, note, pausedReason);
    } else {
      await changeOnboardingStatus(selectedUserId, updateState, note);
    }

    setIsStatusUpdating(false);
    setCurrentPage(0);
    dispatch(clearModalContent());
    await getUpdatedAuditLogs();
    await updateContactPref();
    getActiveTodoForSelectedUser();
  };

  const userDetails = {
    name: '',
    email: selectedUserInfo?.email,
    phone_no: '',
    user_type: selectedUserInfo?.user_type,
  };

  const handleInvite = async () => {
    setIsSendingEmail(true);
    dispatch(clearModalContent());

    try {
      const response = await invite(userDetails);

      dispatch(
        setFlashNotification({
          message: response?.message || 'Successfully invited user',
        }),
      );
      init();
      setIsSendingEmail(false);
    } catch (err) {
      const message = err.response.data.message || 'Failed to invite user';

      dispatch(
        setFlashNotification({
          message,
          isError: true,
          duration: 9000,
        }),
      );

      dispatch(clearModalContent());
      setIsSendingEmail(false);
    }
  };

  const handleSendWelcomeEmail = async () => {
    setIsSendingEmail(true);
    dispatch(clearModalContent());

    try {
      await sendWelcomeEmail(userDetails.email);
      dispatch(
        setFlashNotification({
          message: 'Welcome email sent.',
        }),
      );
      init();
      setIsSendingEmail(false);
    } catch (err) {
      const message = err.response.data.message || 'Failed to send email';

      dispatch(
        setFlashNotification({
          message,
          isError: true,
          duration: 9000,
        }),
      );

      dispatch(clearModalContent());
      setIsSendingEmail(false);
    }
  };

  const getModalContent = (source, todo: any) => {
    const elementSource = todo ? todo.type : source.toLowerCase();

    switch (elementSource) {
      case 'add-note':
        return {
          content: (
            <AddNoteModal
              selectedUserId={selectedUserId}
              noteUpdatedByUser={() => {
                getUpdatedAuditLogs();
                setCurrentPage(0);
              }}
            />
          ),
          header: 'Add Note',
          buttonLabel: 'Add Note',
          className: 'add-note-modal',
        };
      case 'contact-info':
        return {
          content: (
            <ContactPreferencesModal
              selectedUserId={selectedUserId}
              contactPreference={selectedUserInfo?.contact_preference}
              contactPreferenceUpdatedByUser={updateContactPref}
            />
          ),
          header: 'Update Contact Preferences',
          buttonLabel: 'Add Note',
          className: 'contact-preference-modal',
        };
      case 'followUp':
      case 'policyHolderTodo':
      case 'highAcuityTodo':
      case 'creditCardTodo':
      case 'identificationCardTodo':
      case FollowUpTodo.CUSTODY_DOCUMENT_TODO:
        return {
          content: (
            <FollowUpTodoModal
              todo={todo}
              todoId={todo?.id}
              getUpdatedAuditLogs={() => {
                getUpdatedAuditLogs();
                getActiveTodoForSelectedUser();
              }}
            />
          ),
          header:
            todo?.type === 'highAcuityTodo'
              ? 'Screen this Patient for High Acuity'
              : todo?.type === FollowUpTodo.CUSTODY_DOCUMENT_TODO
              ? 'Shared Custody Documents'
              : 'I Followed Up',
          buttonLabel: 'Add Note',
          className: 'followup-modal',
        };

      case 'requestMatchHelpTodo':
        return {
          content: (
            <MatchRequestedModal
              todo={todo}
              getUpdatedAuditLogs={() => {
                getUpdatedAuditLogs();
                getActiveTodoForSelectedUser();
              }}
            />
          ),
          header: 'Match Requested',
          buttonLabel: 'Save',
          className: 'followup-modal',
        };

      case 'insuranceCardTodo':
        return {
          content: (
            <VerifyInsuranceToDo
              todo={todo}
              onVerified={() => {
                getUpdatedAuditLogs();
                getActiveTodoForSelectedUser();
                dispatch(fetchTherapistClientMetaData(selectedUserId));
                getActiveTodoForSelectedUser();
              }}
            />
          ),
          isGeneralPopup: true,
          title: `Verify Insurance`,
          size: 'lg',
          className: 'verify-insurance-information',
        };

      case TodoTypeEnums?.INSURANCE_REQUEST_TODO:
        return {
          content: (
            <InsuranceManagementTodo
              todo={todo}
              onVerified={() => {
                getUpdatedAuditLogs();
                getActiveTodoForSelectedUser();
                dispatch(fetchTherapistClientMetaData(selectedUserId));
                getActiveTodoForSelectedUser();
              }}
            />
          ),
          isGeneralPopup: true,
          header: `New Insurance Request`,
          size: 'lg',
          className: 'verify-insurance-information',
        };

      case TodoTypeEnums?.EHR_USER_CREATION_FAILED_TODO:
        return {
          content: (
            <EhrConnectionIssueTodo
              todo={todo}
              onVerified={() => {
                getUpdatedAuditLogs();
                getActiveTodoForSelectedUser();
                dispatch(fetchTherapistClientMetaData(selectedUserId));
                getActiveTodoForSelectedUser();
              }}
            />
          ),
          isGeneralPopup: true,
          header: `EHR Connection Issue`,
          size: 'lg',
        };

      case 'pause-onboarding':
        return {
          content: (
            <PauseOnboardingModal
              handleOnboardingStatus={handleOnboardingStatus}
              onboardingActionStatus={onboardingActionStatus}
              userType={
                selectedUserInfo?.user_type?.includes(UserTypes?.CLIENT)
                  ? UserTypes?.CLIENT
                  : ''
              }
            />
          ),
          header: t('pauseOnboardingModal.title'),
          className:
            onboardingActionStatus ===
              OnboardingActionStatus?.PAUSE_ONBOARDING &&
            `${
              selectedUserInfo?.user_type?.includes(UserTypes?.CLIENT)
                ? 'pause-onboarding-client'
                : 'pause-onboarding'
            }`,
        };

      case 'reassign':
        return {
          content: (
            <ReassignModal
              reassigned={() => {
                getUpdatedAuditLogs();
                getusersAssignedScheduler();
              }}
              selectedUserId={selectedUserId}
            />
          ),
          header: 'Are you sure you want to reassign this user?',
          buttonLabel: 'Confirm',
        };
      case 'amdUserConflictTodo':
        return {
          content: (
            <VerifyToDo
              todo={todo}
              onAMDVerified={() => {
                getActiveTodoForSelectedUser();
                getUpdatedAuditLogs();
              }}
            />
          ),
          isGeneralPopup: true,
          header: 'Review Possible Duplicate Account',
          size: 'lg',
          className: 'duplicate-amd-accounts',
        };

      case 'invite_therapist':
        return {
          content: (
            <ConfirmationModalContainer
              clickedYes={() => handleInvite()}
              clickedOnNo={() =>
                dispatch(setModalContent({ modalContent: null }))
              }
              dynamicText={
                inviteLabel === 'Invite'
                  ? `Would you like to send an invitation email to this user?`
                  : `Would you like to resend an invitation email to this user?`
              }
            />
          ),
          header: 'Are you sure',
          className: 'followup-modal',
          isWithCancelButton: false,
          isWithCloseButton: false,
        };

      case 'welcome_therapist':
        return {
          content: (
            <ConfirmationModalContainer
              clickedYes={() => {
                handleSendWelcomeEmail();
              }}
              clickedOnNo={() =>
                dispatch(setModalContent({ modalContent: null }))
              }
              dynamicText={`Would you like to send a welcome email to this user?`}
            />
          ),
          header: 'Are you sure',
          className: 'followup-modal',
          isWithCancelButton: false,
          isWithCloseButton: false,
        };

      case 'invite_client':
        return {
          content: (
            <ConfirmationModalContainer
              clickedYes={() => handleInvite()}
              clickedOnNo={() =>
                dispatch(setModalContent({ modalContent: null }))
              }
              dynamicText={
                inviteClientLabel === 'Invite'
                  ? `Would you like to send an invitation email to this user?`
                  : `Would you like to resend an invitation email to this user?`
              }
            />
          ),
          header: 'Are you sure',
          className: 'followup-modal',
          isWithCancelButton: false,
          isWithCloseButton: false,
        };

      case 'appointmentConfirmationTodo':
      case TodoTypeEnums.PROVIDER_APPOINTMENT_CONFIRMATION_TODO:
        return {
          content: (
            <ConfirmAppointmentTodo
              todo={todo}
              onConfirm={() => {
                getUpdatedAuditLogs();
                getActiveTodoForSelectedUser();
                dispatch(fetchTherapistClientMetaData(selectedUserId));
              }}
            />
          ),
          isGeneralPopup: true,
          header: 'Confirm Appointment Request',
          size: 'lg',
        };

      case TodoTypeEnums?.REVIEW_PATIENT_TODO: {
        return {
          content: (
            <ReviewPatientTodo
              todo={todo}
              onConfirm={() => {
                getUpdatedAuditLogs();
                getActiveTodoForSelectedUser();
                dispatch(fetchTherapistClientMetaData(selectedUserId));
              }}
            />
          ),
          isGeneralPopup: true,
          header: `Review Patient`,
          size: 'sm',
        };
      }

      case TodoTypeEnums?.PAYMENT_ISSUE_TODO: {
        return {
          content: (
            <PaymentIssueDetectionTodo
              todo={todo}
              onConfirm={() => {
                getUpdatedAuditLogs();
                getActiveTodoForSelectedUser();
                dispatch(fetchTherapistClientMetaData(selectedUserId));
              }}
            />
          ),
          isGeneralPopup: true,
          header: `Payment Issue Detected`,
          size: 'sm',
        };
      }

      case TodoTypeEnums.VERIFICATION_PROVIDER_TODO: {
        return {
          content: (
            <TrackVerficationStatusTodo
              todo={todo}
              onConfirm={() => {
                getUpdatedAuditLogs();
                getActiveTodoForSelectedUser();
                dispatch(fetchTherapistClientMetaData(selectedUserId));
              }}
            />
          ),
          isGeneralPopup: true,
          header: ` Verify Provider`,
          size: 'sm',
        };
      }

      case TodoTypeEnums?.ADDITIONAL_CONSENT_REQUIRED_TODO: {
        return {
          content: (
            <MarkAsCollectedTodo
              todo={todo}
              onConfirm={() => {
                getUpdatedAuditLogs();
                getActiveTodoForSelectedUser();
                dispatch(fetchTherapistClientMetaData(selectedUserId));
              }}
            />
          ),
          isGeneralPopup: true,
          header: `Mark as Collected`,
          size: 'lg',
        };
      }

      case TodoTypeEnums?.DISPUTE_PAYMENT_TODO: {
        return {
          content: (
            <DisputeTodo
              todo={todo}
              todoId={todo?.id}
              getUpdatedAuditLogs={() => {
                getUpdatedAuditLogs();
                getActiveTodoForSelectedUser();
              }}
            />
          ),
          isGeneralPopup: true,
          header: `Review Provider Refund Request`,
          size: 'sm',
        };
      }

      case TodoTypeEnums?.PRACTICE_OWNER_JOIN_REQUEST_TODO: // falls through

      case TodoTypeEnums?.PROVIDER_JOIN_REQUEST_TODO: {
        return {
          content: (
            <ProviderJoinRequestTodo
              todo={todo}
              todoId={todo?.id}
              getUpdatedAuditLogs={() => {
                getUpdatedAuditLogs();
                getActiveTodoForSelectedUser();
                getusersAssignedScheduler();
              }}
            />
          ),
          isGeneralPopup: true,
          header: `${
            todo?.type === TodoTypeEnums?.PRACTICE_OWNER_JOIN_REQUEST_TODO
              ? 'Practice Owner'
              : 'Provider'
          } Join Request`,
          size: 'lg',
        };
      }

      default:
        break;
    }
  };

  const showModal = async (source, todo: any) => {
    const modalContent = await getModalContent(source, todo);

    dispatch(
      setModalContent({
        modalContent: modalContent.content,
        size: 'sm',
        title: (
          <Typography color="color-28" variant="size-20">
            {modalContent.header}
          </Typography>
        ),
        isWithCloseButton: true,
        isGeneralPopup: true,
        className: modalContent?.className || 'reassign-modal',
        confirmButtonLabel: `${
          modalContent.buttonLabel ? modalContent.buttonLabel : 'Assign'
        }`,
        backDrop: 'static',
      }),
    );
  };

  return (
    <div className="onboarding-page">
      <div className="onboarding">
        <div
          className={`onboarding__main-menu ${
            isActivityLoading && 'text-center'
          }`}
        >
          {isActivityLoading ? (
            <Spinner
              animation="border"
              className="activity_log_loader"
              role="status"
            />
          ) : (
            <div className="activity-board">
              <div className="activity-board__header">
                <div className="activity-header">onboarding activity</div>
                <div className="add-note-header">
                  <Button
                    variant="outline-light"
                    textSize="size-14"
                    className="add-note-btn"
                    buttonName="add-note"
                    onClick={() => showModal('add-note')}
                  >
                    Add Note
                  </Button>
                </div>
              </div>
              <Stepper orientation="vertical" activeStep={-1}>
                {auditLogs.map((value, index) => {
                  return (
                    <Step key={index}>
                      <ActivityBoardRow row={value} key={index} />
                    </Step>
                  );
                })}
              </Stepper>
              {isMoreActivityLoading && (
                <div className="d-flex justify-content-start m-4">
                  <Spinner
                    animation="border"
                    className="activity_log_action_loader"
                    role="status"
                  />
                </div>
              )}
            </div>
          )}
        </div>
        <div className="onboarding__right-menu">
          {activeTodo.length > 0 && activeTodo && (
            <div>
              {activeTodo.map(todo => (
                <ReminderCard
                  onClick={() => showModal('follow-up', todo)}
                  activeTodo={todo}
                />
              ))}
            </div>
          )}
          <div
            className={`info-card ${
              !(activeTodo.length > 0 && activeTodo) && 'mt-0'
            }`}
          >
            <ContactCard
              onClick={showModal}
              selectedUserInfo={selectedUserInfo}
            />
          </div>
          <div className="info-card">
            <PorfileCard onClick={showModal} assignedTo={assignedTo} />
          </div>
          <div className="info-card">
            <div className="reminder-card">
              <Button
                variant="light"
                className={`pause_btn ${
                  onboardingActionStatus ===
                  OnboardingActionStatus?.RESUME_ONBOARDING
                    ? 'resume_btn'
                    : ''
                } ${
                  onboardingActionStatus ===
                  OnboardingActionStatus?.PAUSE_ONBOARDING
                    ? 'pause_button'
                    : ''
                }${
                  onboardingActionStatus ===
                  OnboardingActionStatus?.ONBOARDING_COMPLETE
                    ? 'onboarding_btn'
                    : ''
                }`}
                onClick={() => showModal('pause-onboarding')}
                disabled={
                  onboardingActionStatus ===
                  OnboardingActionStatus?.ONBOARDING_COMPLETE
                }
              >
                <FontAwesomeIcon className="me-2" icon={buttonIcon} />
                {isStatusUpdating
                  ? 'Loading State'
                  : t(PauseOnboardingModalButtonLabels[onboardingActionStatus])}
              </Button>
            </div>
          </div>
          {selectedUserInfo?.user_type?.includes('THERAPIST') ? (
            selectedUserInfo?.status === TherapistClientUserStatus?.INVITED ||
            selectedUserInfo?.status === 'Pre-onboard Complete' ? (
              <div className="invite__container">
                <Button
                  onClick={() => showModal('invite_therapist')}
                  className="pause_btn bg-white"
                  variant={'light'}
                  isProcessing={isSendingEmail}
                >
                  <FontAwesomeIcon className="me-2" icon={faPaperPlane} />
                  {inviteLabel}
                </Button>
              </div>
            ) : (
              <div className="invite__container">
                <Button
                  onClick={() => showModal('welcome_therapist')}
                  className="pause_btn bg-white"
                  variant={'light'}
                  isProcessing={isSendingEmail}
                >
                  <FontAwesomeIcon className="me-2" icon={faPaperPlane} />
                  {inviteLabel}
                </Button>
              </div>
            )
          ) : (
            ''
          )}

          {selectedUserInfo?.user_type?.includes('CLIENT') && (
            <div className="invite__container">
              <Button
                onClick={() => showModal('invite_client')}
                className="pause_btn bg-white"
                variant={'light'}
                isProcessing={isSendingEmail}
              >
                <FontAwesomeIcon className="me-2" icon={faPaperPlane} />
                {inviteClientLabel}
              </Button>
            </div>
          )}
        </div>
      </div>
      <div className="last_div" ref={loadMoreAuditLogTrigger} />
    </div>
  );
}

export default ThearpistClientOnboarding;
